import React, { Component } from 'react'
import Slider from "react-slick"
import ProjectSubscribeForm from './project-subscribe-form'

// Component to fix beforeChange bug rerendering slick
class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }  
  render() {
    return (<>{ this.props.children }</>)
  }
}

class AboutTheArea extends Component {

  render() {

    let { title, items, paddingBottom, projectNewsletter, formTitle, formSendTo } = this.props

    const settings = {
      infinite: true,
      speed: 600,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      cssEase: 'ease',
      swipe: false,
      focusOnSelect: false,
      adaptiveHeight: true,
      pauseOnHover:true
    }

    return (

      <section className={`about-the-area ${paddingBottom ? 'about-the-area--pb' : ''}`}>

      <div className='about-the-area__inner'>

       { items &&

        <div className='about-the-area__items'>
          <BlockUpdate>
            <Slider {...settings}>
                  
              {items.map((el, i) => (

                <div className='about-the-area__slide' key={i}>

                  <div className='about-the-area__item'>

                    <div className='about-the-area__menu'>

                      <ul>
                        <li>{ title }</li>
                      </ul>

                    </div>

                    <div className='about-the-area__content' >

                      <div className='about-the-area__details'>

                        <div className='about-the-area__heading'>  
                          <h3 dangerouslySetInnerHTML={{ __html: el.title }}  />
                        </div>

                        <div className={`about-the-area__copy ${el.singleColumn ? 'about-the-area__copy--single' : ''}`}  id={projectNewsletter ? 'register' : ''}>
                          <div className='copy' dangerouslySetInnerHTML={{ __html: el.content }} />
                          { projectNewsletter && <ProjectSubscribeForm formName={formTitle} agentEmail={formSendTo} />}
                        </div>

                      </div>

                      </div>

                    </div>

                    <div className='about-the-area__image'>
                      <div className='about-the-area__image-wrapper'>
                        <img loading='lazy' src={el.image?.sourceUrl} alt={title} />
                      </div>
                    </div>

                  </div>

              ))}

            </Slider>

          </BlockUpdate>

        </div>

      }

      </div>
            
      </section>
    )
  }
}

export default AboutTheArea
